var render = function () {
  var _vm$user, _vm$forInitial, _vm$user2, _vm$user3, _vm$user4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar bg-neutral-700"
  }, [_c('div', {
    staticClass: "pt-5"
  }, [_c('div', {
    staticClass: "flex px-5 mb-9 h-8 items-center justify-between"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "duration": 100
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/logos/Logo-linknau-new.svg")
    }
  })]), _c('span', {
    staticClass: "cursor-pointer inline-block -mr-2",
    on: {
      "click": function click($event) {
        return _vm.toggleMenu();
      }
    }
  }, [_c('Close', {
    attrs: {
      "width": "40",
      "height": "40"
    }
  })], 1)], 1), _c('div', {
    staticClass: "menu flex items-center justify-between gap-4 px-5 mb-10"
  }, [_c('div', {
    staticClass: "flex gap-4 items-center"
  }, [_vm.user.profile_image ? _c('div', {
    staticClass: "h-10 w-10 bg-cover rounded-full",
    style: "background-image: url(".concat(_vm.user.profile_image, ")")
  }) : _c('div', {
    staticClass: "h-10 w-10 bg-neutral-700 rounded-full flex justify-center items-center"
  }, [_c('p', {
    class: "font-bold text-lg text-white ".concat(((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.name) !== '' && ((_vm$forInitial = _vm.forInitial((_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2.name)) === null || _vm$forInitial === void 0 ? void 0 : _vm$forInitial.length) > 1 ? '' : 'text-xl')
  }, [_vm._v(" " + _vm._s(((_vm$user3 = _vm.user) === null || _vm$user3 === void 0 ? void 0 : _vm$user3.name) !== '' ? _vm.forInitial((_vm$user4 = _vm.user) === null || _vm$user4 === void 0 ? void 0 : _vm$user4.name) : 'A') + " ")])]), _c('div', {
    staticClass: "text-left"
  }, [_c('p', {
    staticClass: "text-white text-lg font-bold leading-tight"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm.user.group ? _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s(_vm.user.group))]) : _vm._e()])]), _c('div', {
    staticClass: "relative text-left user-item"
  }, [_c('span', {
    staticClass: "inline-block absolute top-1/2 leading-0 transform -translate-y-1/2 right-0 cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUser();
      }
    }
  }, [_c('Chevron', {
    attrs: {
      "width": "16",
      "height": "16",
      "direction": _vm.expandUser ? 'up' : 'down',
      "color": "#ffffff"
    }
  })], 1)])]), _vm.expandUser ? _c('div', {
    staticClass: "px-5 relative text-left mb-6"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "inline-block text-yellow text-sm cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar('PROFILE');
      }
    }
  }, [_vm._v("Lihat Profil")])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "inline-block text-yellow text-sm cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar('PASSWORD');
      }
    }
  }, [_vm._v("Ubah Password")])]), _c('div', {}, [_c('span', {
    staticClass: "inline-block text-yellow text-sm cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar('ADDRESS');
      }
    }
  }, [_vm._v("Pengaturan Alamat")])])]) : _vm._e(), _vm._l(_vm.menuList, function (menu, index) {
    return _c('div', {
      key: index
    }, [!menu.submenu ? _c('router-link', {
      staticClass: "flex px-5 py-3 gap-4 items-center transition-all ease-linear duration-200 hover:text-primary-500",
      class: {
        'active-link': _vm.activePath === menu.url
      },
      attrs: {
        "to": menu.url
      }
    }, [_c('span', {
      staticClass: "inline-block flex-shrink-0"
    }, [_c(menu.icon, {
      tag: "component",
      attrs: {
        "width": "24",
        "height": "24"
      }
    })], 1), _c('transition', {
      attrs: {
        "name": "fade",
        "duration": 100
      }
    }, [_c('div', {
      staticClass: "font-medium title whitespace-nowrap "
    }, [_vm._v(_vm._s(menu.title))])])], 1) : _c('div', {
      staticClass: "gap-4 justify-between items-start"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: menu.active,
        expression: "menu.active"
      }],
      attrs: {
        "type": "checkbox",
        "id": "checkbox-".concat(index)
      },
      domProps: {
        "checked": Array.isArray(menu.active) ? _vm._i(menu.active, null) > -1 : menu.active
      },
      on: {
        "change": function change($event) {
          var $$a = menu.active,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(menu, "active", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(menu, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(menu, "active", $$c);
          }
        }
      }
    }), _c('label', {
      staticClass: "font-medium py-3 px-5 flex gap-4 items-center justify-between cursor-pointer transition-all duration-200 hover:text-primary-500",
      attrs: {
        "for": "checkbox-".concat(index)
      }
    }, [_c('div', {
      staticClass: "flex gap-4 items-center justify-start"
    }, [_c('span', {
      staticClass: "inline-block flex-shrink-0"
    }, [_c(menu.icon, {
      tag: "component",
      attrs: {
        "width": "24",
        "height": "24"
      }
    })], 1), _c('transition', {
      attrs: {
        "name": "fade",
        "duration": 100
      }
    }, [_c('p', {
      staticClass: "font-medium title whitespace-nowrap "
    }, [_vm._v(_vm._s(menu.title))])])], 1), _c('Chevron', {
      attrs: {
        "color": "white",
        "width": "12",
        "height": "12",
        "direction": menu.active ? 'up' : 'down'
      }
    })], 1), _c('div', {
      staticClass: "submenu",
      class: {
        active: menu.active
      }
    }, _vm._l(menu.submenu, function (submenu, idx) {
      return _c('router-link', {
        key: idx,
        staticClass: "flex px-6 py-2 gap-4 items-center transition-all duration-200 hover:text-primary-500",
        class: {
          'active-link': _vm.activePath === submenu.url
        },
        attrs: {
          "to": submenu.url
        }
      }, [_c('div', {
        staticClass: "font-medium"
      }, [_vm._v(_vm._s(submenu.title))])]);
    }), 1)])], 1);
  }), _c('div', {
    staticClass: "cursor-pointer text-white border border-white text-sm p-2 rounded mx-5 mt-5",
    on: {
      "click": function click($event) {
        return _vm.doLogout();
      }
    }
  }, [_vm._v("Logout")])], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }